'use strict';

define('composer/drag', [], function () {
	var drag = {};
	let positionImages = [];
	const wrapperWidth = window.innerWidth;
	const imageWidth = parseInt((wrapperWidth - 72) / 3, 10);
	const rowHeight = imageWidth + 12;
	const positions = [];

	for (var i = 0; i < 9; i += 1) {
		const p = { top: 12 + (parseInt(i / 3, 10) * rowHeight), left: 24 + ((i % 3) * rowHeight) };
		positions.push(p);
	}

	let wrapper = null;
	let activeEl = null; // 被拖拽的元素
	let activeElIndex = null; // 被拖拽元素的下标
	let activePoIndex = -1; // 被拖拽位置的下标
	let targetPoIndex = -1;
	let startClientX = null;
	let startClientY = null;
	let startOffsetX = null;
	let startOffsetY = null;
	let imagesEl = null;
	let tempPositionImages = [];
	let touching = false;
	let touchTimeout = 0;

	drag.init = function () {
		positionImages = [];
		tempPositionImages = [];
		imagesEl = null;
		activeEl = null;
		touching = 0;
		wrapper = $('.composer-container .img-wrapper');
		wrapper.on('touchstart', '.img-item', function (event) {
			// 开始 选中被拖动元素，添加激活样式
			if (touchTimeout) {
				clearTimeout(touchTimeout);
			}
			touching = false;
			touchTimeout = setTimeout(() => {
				touching = true;
				touchTimeout = 0;
				const clientRect = event.target.getBoundingClientRect();
				startOffsetX = event.touches[0].clientX - clientRect.x;
				startOffsetY = event.touches[0].clientY - clientRect.y;
				moveStart($(this), event.touches[0]);
			}, 300);
		});
		wrapper.on('touchmove', function (event) {
			// 移动 获取鼠标位置更新当前被拖动元素位置
			if (touchTimeout) {
				clearTimeout(touchTimeout);
				touchTimeout = 0;
				return;
			}
			if (touching && activePoIndex > -1) {
				event.preventDefault();
				event.stopPropagation();
				moveImages(event.changedTouches[0]);
			}
		});
		wrapper.on('touchend', function () {
			moveEnd();
			if (touchTimeout) {
				clearTimeout(touchTimeout);
				touchTimeout = 0;
				touching = false;
			}
		});
		wrapper.on('touchcancel', function () {
			moveEnd();
			if (touchTimeout) {
				clearTimeout(touchTimeout);
				touchTimeout = 0;
				touching = false;
			}
		});
		wrapper.on('mousedown', '.img-item', function (event) {
			if (touchTimeout) {
				clearTimeout(touchTimeout);
			}
			touching = false;
			touchTimeout = setTimeout(() => {
				touching = true;
				touchTimeout = 0;
				startOffsetX = event.offsetX;
				startOffsetY = event.offsetY;
				moveStart($(this), event);
			}, 300);
		});
		wrapper.on('mousemove', function (event) {
			// 移动 获取鼠标位置更新当前被拖动元素位置
			if (touchTimeout) {
				clearTimeout(touchTimeout);
				touchTimeout = 0;
				return;
			}
			if (touching && activePoIndex > -1) {
				event.preventDefault();
				event.stopPropagation();
				moveImages(event);
			}
		});
		wrapper.on('mouseup', function () {
			moveEnd();
			if (touchTimeout) {
				clearTimeout(touchTimeout);
				touchTimeout = 0;
				touching = false;
			}
		});
	};

	drag.addImage = function (info) {
		var originImageCount = imagesEl ? imagesEl.length : 0;
		var p = positions[originImageCount];
		wrapper.append(`<div uploadid="${info.id}" class="img-item uploading" data-index="${originImageCount}" style="width: ${imageWidth}px; height: ${imageWidth}px; top: ${p.top}px; left: ${p.left}px"><div class="img-bg" style="background-image: url(${URL.createObjectURL(info.file)})"></div><i class="icon-nodeBB-remove img-remove"></i></div>`);
		positionImages.push({ elIndex: originImageCount });
		originImageCount += 1;
		wrapper.css('height', `${(Math.ceil(originImageCount / 3) * rowHeight) + 12}px`);
		imagesEl = wrapper.find('.img-item');
	};

	drag.remove = function (index) {
		imagesEl = wrapper.find('.img-item');
		positionImages = positionImages.filter(i => i.elIndex !== index);
		positionImages.forEach((i, idx) => {
			if (i.elIndex > index) {
				i.elIndex -= 1;
			}
			const image = imagesEl.eq(idx);
			image.attr('data-index', image.index());
		});
		positionImages.forEach((i, index) => {
			const image = imagesEl.eq(i.elIndex);
			image.css('top', `${positions[index].top}px`);
			image.css('left', `${positions[index].left}px`);
		});
	};

	drag.getPositionImages = function () {
		return positionImages;
	};

	// 开始 选中被拖动元素，添加激活样式
	function moveStart(el, ev) {
		$('#__vconsole').addClass('no-select');
		startClientX = ev.clientX;
		startClientY = ev.clientY;
		activePoIndex = -1;
		targetPoIndex = -1;
		activeElIndex = parseInt(el.attr('data-index'), 10);
		positionImages.forEach((i, index) => {
			if (i.elIndex === activeElIndex) {
				activePoIndex = index;
			}
		});
		activeEl = el;
		imagesEl.removeClass('last-active');
		el.addClass('active');
		el.addClass('last-active');
	}

	// 碰撞，修改 index
	function moveImages(ev) {
		if (!activeEl) {
			return;
		}
		const currentTop = positions[activePoIndex].top + (ev.clientY - startClientY);
		const currentLeft = positions[activePoIndex].left + (ev.clientX - startClientX);
		activeEl.css('top', `${currentTop}px`);
		activeEl.css('left', `${currentLeft}px`);

		// 找到鼠标位置对应的position
		const mouseTop = currentTop + startOffsetY;
		const mouseLeft = currentLeft + startOffsetX;
		let currentPoIndex = -1;
		positions.forEach((i, index) => {
			if (index < positionImages.length &&
				mouseTop > i.top && mouseTop < i.top + imageWidth &&
				mouseLeft > i.left && mouseLeft < i.left + imageWidth) {
				currentPoIndex = index;
			}
		});

		if (activePoIndex > -1 && currentPoIndex > -1) {
			targetPoIndex = currentPoIndex;
			let startIndex = null;
			let endIndex = null;
			if (currentPoIndex > activePoIndex) {
				startIndex = activePoIndex;
				endIndex = currentPoIndex;
			} else {
				startIndex = currentPoIndex;
				endIndex = activePoIndex;
			}

			tempPositionImages = [];
			positionImages.forEach((i, index) => {
				if (index >= startIndex && index <= endIndex) {
					if (currentPoIndex > activePoIndex && index < endIndex) {
						tempPositionImages.push(positionImages[index + 1]);
					} else if (currentPoIndex < activePoIndex && index > startIndex) {
						tempPositionImages.push(positionImages[index - 1]);
					} else {
						tempPositionImages.push(positionImages[activePoIndex]);
					}
				} else {
					tempPositionImages.push(i);
				}
			});

			tempPositionImages.forEach((i, index) => {
				if (index !== currentPoIndex) {
					const image = imagesEl.eq(i.elIndex);
					image.css('top', `${positions[index].top}px`);
					image.css('left', `${positions[index].left}px`);
				}
			});
		}
	}

	// 结束 修改被拖动元素 index，删除激活样式
	function moveEnd() {
		$('#__vconsole').removeClass('no-select');
		if (!activeEl) {
			return;
		}
		$('.img-item').removeClass('active');
		if (targetPoIndex > -1) {
			activeEl.css('top', `${positions[targetPoIndex].top}px`);
			activeEl.css('left', `${positions[targetPoIndex].left}px`);
			positionImages = tempPositionImages;
		} else if (activePoIndex > -1) {
			activeEl.css('top', `${positions[activePoIndex].top}px`);
			activeEl.css('left', `${positions[activePoIndex].left}px`);
		}
		targetPoIndex = -1;
		activeEl = null;
		activePoIndex = -1;
		startClientX = null;
		startClientY = null;
	}

	return drag;
});
